import LL55ScanSurvey from "../../pages/LL55SurveyScan";
import SurveyEntry from "../../pages/SurveyScan";

export const Public = [
  {
    path: "/lead-compliance-form",
    element: <SurveyEntry />,
  },
  {
    path: "/ll55-survey-scan",
    element: <LL55ScanSurvey />,
  },
];
